import {DocumentAmendment} from "common/flowmaster/types/amendment";
import {stripClauseNumberPrefix} from "../clause_number_utils";
import {generateChainedTexts} from "./delete";

function stripClauseNumbers(text: string): string {
  // Matches all clause numbers such as 1
  const clauseNumberRegex = /\s*(([0-9]+\.)+[0-9]+|([A-Za-z]+\.)+[A-Za-z]+|[0-9]+\.|[A-Za-z]+\.|\([A-Za-z0-9]+\))\s+/g;
  return text.replace(clauseNumberRegex, " ").replace(/\s+/g, " ").trim();
}

export function generateDeleteClauseSubAmendments(
  amendment: DocumentAmendment,
): DocumentAmendment {
  const normalizedBeforeText = stripClauseNumbers(amendment.before_text);
  const normalizedAfterText = stripClauseNumbers(amendment.after_text);

  const deletedText = amendment.deleted_text;
  const splitTexts = deletedText
    .split("\n")
    .filter(line => line.length > 0)
    .map(stripClauseNumberPrefix);

  const chainedTexts = generateChainedTexts(
    splitTexts,
    normalizedBeforeText,
    normalizedAfterText,
  );
  const replaceText = chainedTexts[0];
  const deleteTexts = chainedTexts.slice(1, chainedTexts.length);

  const replaceSubAmendment = {
    ...amendment,
    ...replaceText,
    action_type: "replace",
    added_text: "Not used",
  };

  const deleteSubAmendments = deleteTexts.map(deleteText => ({
    ...amendment,
    ...deleteText,
    action_type: "delete",
    comment: "",
  }));

  return {
    ...amendment,
    subAmendments: [replaceSubAmendment, ...deleteSubAmendments],
  };
}
